<template>
    <div style="margin: 2em;min-height: 80vh">
        <b-navbar toggleable="lg" class="bg-white-color" style="padding: 0 0 0.75em 0;border-bottom: 1px solid #2DA1A9;">
            <b-button v-b-modal.modal-1 class="autopsys-button font20" @click="offTableRefers" style="padding: 0.25em 2.25em">+ เหตุการณ์</b-button>
            <b-modal id="modal-1" hide-footer>
                <div class="row" style="padding-right: 10px;justify-content: center;padding-left: 10px">
                    <div class="col-6">
                        <b-button class="event-button" style="font-size: 17px" @click="goToEvent(1)" block>เหตุการณ์ใหม่ <br>ชันสูตรที่เกิดเหตุ</b-button>
                    </div>
                    <div class="col-6">
                        <b-button class="event-button-2" style="font-size: 17px; " @click="goToEvent(2)" block>เหตุการณ์ใหม่ <br>ชันสูตรที่โรงพยาบาล</b-button>
                    </div>
                    <div class="col-12">
                        <b-button class="refer_in_event-button " @click="onTableRefers" block>Refer Case</b-button>
                    </div>
                    <div v-if="!onTableRefer" class="col-12" style="text-align: center;padding-top: 30px;padding-bottom: 15px">
                        กรุณากดปุ่ม Refer Case เพื่อดูข้อมูลล่าสุด
                    </div>
                    <b-table v-if="onTableRefer" responsive
                             class="mt-5"
                             striped hover
                             :items="itemsRefer"
                             :fields="fields_table_event"
                    >
                        <template v-slot:cell(refer)="row">
                            <b-button size="md" style="color: #2DA1A9;" class="refer-button mr-1" @click="receiveCase(row)">
                                รับ
                            </b-button>
                        </template>
                    </b-table>
                    <p>{{responseMsg}}</p>
                </div>
            </b-modal>
<!--            <profile-status/>-->
        </b-navbar>
        <div class="row py-3">

<!--            <div class="col-md-3 mt-1">-->
<!--                <multiselect class="multiselect-style" v-model="value"-->
<!--                             :options="optionProvince"-->
<!--                             label="name"-->
<!--                             select-label=""-->
<!--                             selectedLabel=""-->
<!--                             deselect-label=""-->
<!--                             placeholder="เลือกจังหวัด"-->
<!--                             track-by="name"-->
<!--                />-->
<!--            </div>-->
            <b-input-group @keyup.enter="onGetSearch()">
                <div class="col-md-3 px-0 mt-1 pl-3 pr-3">
                    <input class="custom-input mt-0" type="text" placeholder="ค้นหา" v-model="searchText">
                </div>
                <div class="col-md-3 mt-1">
<!--                    <b-form-datepicker class="datepick"-->
<!--                                       placeholder="วันที่เริ่มต้น"-->
<!--                                       id="datepicker-dateformat1"-->
<!--                                       :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"-->
<!--                                       locale="th"-->
<!--                                       v-model="startDate"-->
<!--                    ></b-form-datepicker>-->
                    <custom-date-picker  :name="'startDate'" :placeholder="'วันที่เริ่มต้น วว/ดด/ปปปป'" :input-date="startDate"  @date-update="dateUpdate"/>
                </div>
                <div class="col-md-3 mt-1">
<!--                    <b-form-datepicker class="datepick"-->
<!--                                       placeholder="วันที่สิ้นสุด"-->
<!--                                       id="datepicker-dateformat2"-->
<!--                                       :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"-->
<!--                                       locale="th"-->
<!--                                       v-model="endDate"-->
<!--                    ></b-form-datepicker>-->
                    <custom-date-picker :name="'endDate'" :placeholder="'วันที่สิ้นสุด วว/ดด/ปปปป'" :input-date="endDate"  @date-update="dateUpdate"/>
                </div>
                <div class="col-md-3 m-auto">
                  <b-button class="d-inline-flex autopsy-button m-1" @click="onGetSearch()"><b-icon-search></b-icon-search>ค้นหา
                    </b-button>
                    <b-button class="d-inline-flex autopsy-button m-1" name="export" @click="onGetExport()"><b-icon-file-earmark-excel></b-icon-file-earmark-excel>Excel
                    </b-button>
                </div>
            </b-input-group>
        </div>


        <div>

            <b-tabs v-model="tabIndex" lazy>
                <!-- ชันสูตรที่เกิดเหตุ  -->
                <tab-data :name="'ชันสูตรที่เกิดเหตุ'"
                          :cases="casesAtSituation"></tab-data>

                <!-- ชันสูตรที่โรงพยาบาล  -->
                <tab-data
                        :name="'ชันสูตรที่โรงพยาบาล'"
                          :cases="casesAtHospital"></tab-data>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ProfileStatus from "../ProfileStatus";
    import axios from "axios"
    import url from "../../util/Constants"
    import { page } from 'vue-analytics'
    import TabData from "../TabData";
    import CustomDatePicker from "../DatePicker";
    import moment from "moment";

    var fieldsStyle = {
        thStyle: {color: '#616161'},
    };
    export default {
        name: "DataReport",
        components: {CustomDatePicker, TabData, ProfileStatus},
        created() {
            this.$store.dispatch("Common/setProvince");
            this.$store.dispatch("Eventform/onGetCaseSituation");
            this.$store.dispatch("Eventform/onGetCaseHospital");

        },
        computed: {
            // rows() {
            //     return this.dataCaseform.length
            // },
            ...mapState({
                optionProvince: state => {
                    return state.Common.provinces;
                },
                casesAtSituation: state=>{
                    return state.Eventform.casesAtSituation;
                },
                casesAtHospital: state=>{
                    return state.Eventform.casesAtHospital;
                },
                users: state=>{
                    return state.Auth.users;
                },
            })
        },
        data() {
            return {
                responseMsg: '',
                onTableRefer: false,
                itemsRefer: [],
                tabIndex: 0,
                fields_table_event: [
                    {
                        key: 'refer',
                        label: '',
                        sortable: false,
                        ...fieldsStyle
                    },
                    {
                        key: 'received_case_date',
                        label: 'วันที่รับ',
                        sortable: false,
                        formatter: (value, key, item) => {
                            return value ? moment(value).add(543, 'y').format('DD/MM/YYYY') : null
                        },
                        ...fieldsStyle
                    },
                    {
                        key: 'case_id',
                        label: 'เลขชันสูตร',
                        sortable: false,
                        ...fieldsStyle
                    },
                    {
                        key: 'refer_by_name',
                        label: 'ที่มา',
                        sortable: false,
                        ...fieldsStyle
                    },
                    {
                        key: 'dead_gender',
                        label: 'เพศ',
                        sortable: false,
                        ...fieldsStyle
                    },{
                        key: 'dead_age',
                        label: 'อายุ',
                        sortable: false,
                        ...fieldsStyle
                    },

                ],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },
                show: false,
                valueHospital: '',
                value: '',
                options: ['Select option', 'options', 'selected', 'mulitple', 'label', 'searchable', 'clearOnSelect', 'hideSelected', 'maxHeight', 'allowEmpty', 'showLabels', 'onChange', 'touched'],
                searchText:'',
                startDate:'',
                endDate:'',
            }
        },
        methods: {
            dateUpdate(name, date){
                if(name === 'startDate'){
                    this.startDate = date;
                }

                if(name === 'endDate'){
                    this.endDate = date;
                }
            },
            async onTableRefers() {
                this.onTableRefer = true;
                console.log('สถานะTable',this.onTableRefer)
                await this.$store.dispatch("Eventform/onGetNewReferCase",this.users.hospcode).then((res)=>{
                    console.log('onGetNewReferCase',res)
                    if(res && res.length > 0){
                        this.itemsRefer = res
                        this.responseMsg = ''
                    } else {
                        this.itemsRefer = []
                        this.responseMsg = 'ไม่พบเคส'
                    }
                });
            },
            offTableRefers() {
                this.onTableRefer = false;
                console.log('สถานะTable',this.onTableRefer)
            },
            linkClass(idx) {
                if (this.tabIndex === idx) {
                    return ['bg-light', 'text-info']
                } else {
                    return ['text-info' ]
                }
            },
            async goToEvent(id) {
                console.log("go to question form")
                await this.$store.dispatch("Eventform/clearFormData");
                await this.$store.dispatch("Eventform/setCaseID",id).then(()=>{
                    const path = `/question-form/1`
                    if (this.$route.path !== path) this.$router.push(path)
                });
            },

            onGetSearch(){
              if (this.startDate ==null || this.startDate == 'Invalid date'){
                this.startDate = ''
              }
              if (this.endDate ==null || this.endDate == 'Invalid date'){
                this.endDate = ''
              }
                let data = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    searchText: this.searchText,
                    type:(this.tabIndex + 1)
                }
                // alert(data.startDate)
                this.$store.dispatch("Eventform/onGetSearch",data)
                this.$ga.event("Search","Eventform/onGetSearch","Search")

            },
            onGetExport(dataExport){
                this.dataExportCases=dataExport
                let data = {
                    hospital_code: this.users.hospcode,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    searchText: this.searchText,
                }
                this.$store.dispatch("Eventform/onGetExport",data)
                this.$ga.event("Export/Excel","Eventform/onGetExport","Excel")
            },
            track () {
                page('/home')
            },
            async receiveCase(data) {
                let caseid = data.item
                caseid['isReceived'] = true
                caseid['isRefer'] = 1
                await this.$store.dispatch("Eventform/clearFormData");
                await this.$store.dispatch("Eventform/onGetCaseID",caseid);
                await this.$store.dispatch("Eventform/onGetAppearancesID",caseid);
                await this.$store.dispatch("Eventform/onGetEvidence",caseid);
                await this.$store.dispatch("Eventform/onGetTransformationID",caseid).then(()=>{
                    const path = `/question-form/1`
                    if (this.$route.path !== path) this.$router.push(path)
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .bg-primary {
        color: #2DA1A9;
    }
    .email-button {
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border: 3px solid #2DA1A9;
        border-radius: 30px;
        padding: 0.5em 2.25em;
    }
    .autopsys-button {
        background: #2DA1A9;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border: 3px solid #2DA1A9;
        border-radius: 30px;
        padding: 0.5em 2.25em;
    }
    .refer_in_event-button {
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border: 3px solid #a92d50;
        color: #a92d50;
        border-radius: 15px;
        padding: 0.5em 2.25em;
        font-size: 17px;
        font-weight: bold;
        height: 70px;
    }
    .event-button {
        background: #2DA1A9;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border: 3px solid #2DA1A9;
        border-radius: 15px;
        padding: 0.5em 1.25em;
        margin-bottom: 1em;
        /*height: 70px;*/
    }

    .event-button-2 {
        background: #ef8349;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border: 3px solid #ef8349;
        border-radius: 15px;
        padding: 0.5em 1.25em;
        margin-bottom: 1em;
        /*height: 70px;*/
    }


    .refer-button {
        background: #FFFFFF;
        border: 1px solid #2da1a9;
        box-sizing: border-box;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 30px;
    }
</style>
